// What a deduplication run did, as the job's details show it (Golden Nominal maintenance): its
// counts, and what to do next when it could not finish, skipped clusters, or left work undone.

const COUNTS = [
    ["deduplicatedRecords", "Duplicates removed"],
    ["retainedDuplicates", "Duplicates merged but kept"],
    ["autoMergedClusters", "Merged into golden records"],
    ["heldClusters", "Merges held for a steward"],
    ["heldDismissed", "Holds a steward dismissed"],
    ["birthsCreated", "Golden records created"],
    ["birthsResumed", "Golden record creations finished"],
    ["birthsLinked", "Linked to golden records created earlier"],
    ["birthsEnriched", "Golden records that took in new values"],
    ["birthsHeld", "Golden record creations held for a steward"],
    ["birthsDeferred", "Golden record creations left for the next run"],
    ["birthNominationsSkipped", "Survivor picks not merged: a golden record is created instead"],
    ["birthPkCollisions", "Not created: primary key already golden"],
    ["birthsAbandoned", "Golden record creations given up"],
    ["birthsSkipped", "Golden record creations skipped this run"],
    ["nonGoldenClustersLeft", "Clusters without a golden record left unchanged"],
    ["staleClusters", "Clusters skipped: records changed after the search"],
    ["unverifiedClusters", "Clusters from an older search, not checked for changes"],
    ["reviewItemsRaised", "Review items raised"],
    // Work left undone: deduplication should run again.
    ["birthFailures", "Golden record creations failed"],
    ["heldNotQueued", "Held merges not queued for review"],
    ["gateSkippedClusters", "Merges into golden records skipped: survivorship rules unavailable"],
    ["reviewItemFailures", "Review items that could not be raised"],
    ["reviewItemsOverflow", "Review items over the run's limit"],
];

// Counts that mean work was left undone, which another run of deduplication picks up.
const RUN_AGAIN = ["birthFailures", "heldNotQueued", "gateSkippedClusters", "reviewItemFailures"];

// Failures whose own message says what to do; any other is not shown as guidance (it can be an
// internal error's text).
const KNOWN_ERRORS = ["DEDUP_ROWS_STALE", "GOLDEN_DATASETS_UNAVAILABLE", "BIRTHS_UNAVAILABLE", "GOLDEN_MAINTENANCE_OFF", "SCHEMA_LOCK_LOST", "SCHEMA_LOCKED"];

/**
 * @param {object|null} runInfo  the deduplication job's runInfo
 * @returns {{ counts: { key: string, label: string, value: number }[], prompt: string | null }}
 *          counts: those above zero, in a fixed order; prompt: what to do next, if anything
 */
export function dedupRunSummary(runInfo) {
    const info = runInfo || {};
    const counts = COUNTS.filter(([key]) => Number(info[key]) > 0).map(([key, label]) => ({ key, label, value: Number(info[key]) }));
    const error = info.error || null;
    let prompt = null;
    if (error && error.code) {
        // The run stopped: why, first (the search re-run while it ran says to deduplicate the new results).
        prompt = KNOWN_ERRORS.includes(error.code) && error.message ? error.message : "The deduplication did not finish. Run it again.";
    } else if (Number(info.staleClusters) > 0) {
        prompt = "Records changed after the duplicate search, so some clusters were left as they were. Run the duplicate search again, then deduplicate its new results.";
    } else if (RUN_AGAIN.some((key) => Number(info[key]) > 0)) {
        prompt = "Some of the work was left undone. Run deduplication again to finish it.";
    }
    return { counts, prompt };
}
